export function useUseragent() {
    return {
        getUserAgent: function () {
            const userAgent = navigator.userAgent
            const sqbMatch = userAgent.match("SQB")
            const ofbMatch = userAgent.match("OFB")
            const alifMatch = userAgent.match("Alif")
            const paymeMatch = userAgent.match("Payme")
            const xaznaMatch = userAgent.match("xazna")
            const paynetMatch = userAgent.match("paynet")
            const davrMatch = userAgent.match("Davrbank")
            const osonMatch = userAgent.match("oson_app")
            const apexMatch = userAgent.match("Apexbank")
            const qrmenuMatch = userAgent.match("QrMenu")
            const humopayMatch = userAgent.match("HUMOPAY")
            const clickMatch = userAgent.match("Click_SuperApp") || getCookie("click-platform")
            const mobileChromeMatch = userAgent.match("CriOS")
            const oqtepaMatch = userAgent.match("myapp.oqtepa")
            const barakaMatch = userAgent.match("BarakaMobile")
            const multicardMatch = userAgent.match("Multicard")
            const allianceMatch = userAgent.match("AlliancePay")
            const tezkorIosMatch = userAgent.match("iOS Tezkor")
            const samsungMatch = userAgent.match("SamsungBrowser")
            const rahmatMobileMatch = userAgent.match("RahmatMobile")
            const tezkorAndroidMatch = userAgent.match("Uzum Tezkor")
            const alipayClientMatch = userAgent.match("AlipayClient")
            const alipayConnectMatch = userAgent.match("AlipayConnect")
            const korzinkaGoMatch = userAgent.match("KorzinkaGo/Standalone")
            const mobileSafariMatch = userAgent.match(/(iPod|iPhone|iPad)/) && userAgent.match(/AppleWebKit/)

            if (multicardMatch !== null)
                return 'multicard'
            if (rahmatMobileMatch !== null)
                return 'rahmat'
            else if (osonMatch !== null)
                return 'oson'
            else if (apexMatch !== null)
                return 'apexbank'
            else if (humopayMatch !== null)
              return 'humopay'
            else if (paymeMatch !== null)
                return 'payme'
            else if (paynetMatch !== null)
                return 'paynet'
            else if (sqbMatch !== null)
                return 'sqb'
            else if (davrMatch !== null)
                return 'davrbank'
            else if (xaznaMatch !== null)
                return 'xazna'
            else if (alifMatch !== null)
              return 'alif'
            else if (ofbMatch !== null)
                return 'orientfinancebank'
            else if (allianceMatch !== null)
              return 'asiaalliancebank'
            else if (qrmenuMatch !== null)
                return 'qrmenu'
            else if (oqtepaMatch !== null)
                return 'oqtepa'
            else if (barakaMatch !== null)
                return 'baraka'
            else if (tezkorIosMatch !== null || tezkorAndroidMatch !== null)
                return 'tezkor'
            else if (alipayClientMatch !== null)
                return 'alipayClient'
            else if (alipayConnectMatch !== null)
                return 'alipayConnect'
            else if (korzinkaGoMatch !== null)
                return 'korzinkaGo'
            else if (samsungMatch !== null)
                return 'samsung'
            else if (clickMatch !== undefined)
              return 'click'
            else if (mobileSafariMatch !== null)
                return 'mobileSafari'
            else if (mobileChromeMatch !== null)
                return 'mobileChrome'
            else
                return 'browser'
        },
        getOs: function () {
            if (/android/i.test(navigator.userAgent)) {
               return "ANDROID"
            } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
                return "IOS"
            }
            return "WEB"
        }
    }
}
function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1];
}